export default "__VITE_ASSET__DcF47lLy__"